import React from 'react'

import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const Wrapper = styled.div`
    @media (prefers-reduced-motion: no-preference) {
        animation-name: ${fadeIn};
        animation-fill-mode: backwards;
    }
`

function FadeIn({
    duration = 300,
    delay = 0,
    children,
    ...delegated
}: {
    duration: number
    delay: number
    children?: any // eslint-disable-line @typescript-eslint/no-explicit-any
    delegated?: {
        new (): CSSStyleDeclaration
        prototype: CSSStyleDeclaration
    }
}) {
    return (
        <Wrapper
            {...delegated}
            style={{
                ...(delegated || {}),
                animationDuration: `${duration}ms`,
                animationDelay: `${delay}ms`,
            }}
        >
            {children}
        </Wrapper>
    )
}

export default FadeIn
